/*
 * action types
 */
export const CHANGE_LANG = "CHANGE_LANG",
	FETCHING = "FETCHING",
	CHOOSE_TEAM = "CHOOSE_TEAM",
	SET_SERVICES = "SET_SERVICES",
	UPDATE_SERVICE = "UPDATE_SERVICE",
	SET_CZAS_PRACY = "SET_CZAS_PRACY",
	SET_MESSAGE = "SET_MESSAGE",
	SET_DATE = "SET_DATE",
	SET_ACTIVE_MENU = "SET_ACTIVE_MENU";

export const changeLanguage = (language) => {
	return { type: CHANGE_LANG, lang: language };
};

export const fetchLoaderRun = (status) => {
	return { type: FETCHING, status };
};

export const changeTeam = (team) => {
	return { type: CHOOSE_TEAM, ekipa: team };
};

export const setSetvices = (services, stepBtnStatus = false) => {
	return { type: SET_SERVICES, services, stepBtn: stepBtnStatus };
};

export const updateService = (object) => {
	return { type: UPDATE_SERVICE, updated: object };
};

export const setCzasPracy = (value) => {
	return { type: SET_CZAS_PRACY, czas: value };
};

export const setMessage = (typeMessage, text) => {
	return { type: SET_MESSAGE, typeMessage, text };
};

export const setNewDate = (date, flag) => {
	return { type: SET_DATE, date, flag };
};

export const setActiveMenu = (id) => {
	return { type: SET_ACTIVE_MENU, id };
};
